import React from 'react';
import PropTypes from 'prop-types';
import Form from 'react-bootstrap/Form';
import Col from 'react-bootstrap/Col';
import cn from 'classnames';
import { Field, useFormikContext } from 'formik';
import { Checkbox, InputPhone, ValidatedFormInputField } from 'ui';
import DateInputField from '../../components/DateInputField';
import styles from '../../UserDetails.module.css';

const PersonalInfoSection = ({
    confirmUserInformation,
    source,
    disableField,
    isMiddleNameRequired,
    emailVerified,
    phoneVerified,
    conditionallyRequired,
    handleCheckbox,
}) => {
    const formik = useFormikContext();
    const { values, touched, errors, setFieldValue } = formik;

    return (
        <>
            <p className={styles.sectionHeader}>Personal Information</p>

            <Form.Row className={styles.formRow}>
                <Col xs="6">
                    <Form.Label className={styles.formLabel}>First Name*</Form.Label>
                    <Field
                        type="text"
                        name="firstName"
                        variant="outlined"
                        component={ValidatedFormInputField}
                        placeholder="Enter first name"
                        confirmUserInformation={confirmUserInformation}
                        source={source}
                        disabled={disableField}
                    />
                </Col>
                <Col xs="6">
                    <Form.Label className={styles.formLabel}>
                        Middle Name{isMiddleNameRequired}
                    </Form.Label>
                    <Field
                        type="text"
                        variant="outlined"
                        name="middleName"
                        placeholder="Enter middle name"
                        component={ValidatedFormInputField}
                        confirmUserInformation={confirmUserInformation}
                        disabled={values.acceptMiddleName || disableField}
                        source={source}
                    />
                    <label className={styles.checkBox}>
                        <Field
                            component={Checkbox}
                            name="acceptMiddleName"
                            size="xs"
                            onChange={handleCheckbox}
                            disabled={disableField}
                        />
                        <span className={styles.checkBoxText}>I don't have a middle name</span>
                    </label>
                </Col>
            </Form.Row>

            <Form.Row className={styles.formRow}>
                <Col xs="6">
                    <Form.Label className={styles.formLabel}>Last Name*</Form.Label>
                    <Field
                        type="text"
                        name="lastName"
                        variant="outlined"
                        placeholder="Enter last name"
                        component={ValidatedFormInputField}
                        confirmUserInformation={confirmUserInformation}
                        source={source}
                        disabled={disableField}
                    />
                </Col>
                <Col xs="6">
                    <DateInputField
                        label="Date of Birth*"
                        name="dob"
                        value={values.dob}
                        placeholder="MM-DD-YYYY"
                        onChange={(date) => setFieldValue('dob', date)}
                        error={touched.dob && Boolean(errors.dob)}
                        helperText={touched.dob && errors.dob}
                        customStyle={styles.dobInput}
                        disabled={disableField}
                    />
                </Col>
            </Form.Row>

            <Form.Row className={styles.formRow}>
                <Col xs="12">
                    <Form.Label className={styles.formLabel}>
                        Email{emailVerified ? '' : '*'}
                    </Form.Label>
                    <Field
                        type="email"
                        name="email"
                        variant="outlined"
                        placeholder="Enter email id"
                        component={ValidatedFormInputField}
                        confirmUserInformation={confirmUserInformation}
                        source={source}
                        disabled={emailVerified || disableField}
                    />
                </Col>
            </Form.Row>

            <Form.Row className={cn(styles.formRow, styles.phoneRow)}>
                <Col xs="12">
                    <InputPhone
                        label={`Phone Number${conditionallyRequired('phone')}`}
                        name="phone"
                        placeholder="Enter phone number"
                        value={values.phone}
                        error={touched.phone && Boolean(errors.phone)}
                        helperText={touched.phone && errors.phone}
                        form={formik}
                        disabled={disableField || phoneVerified}
                    />
                </Col>
            </Form.Row>
        </>
    );
};

PersonalInfoSection.propTypes = {
    confirmUserInformation: PropTypes.bool,
    source: PropTypes.string,
    disableField: PropTypes.any,
    isMiddleNameRequired: PropTypes.string,
    emailVerified: PropTypes.any,
    phoneVerified: PropTypes.any,
    conditionallyRequired: PropTypes.func,
    handleCheckbox: PropTypes.func,
};

export default PersonalInfoSection;
